// extracted by mini-css-extract-plugin
module.exports = {"container":"TriggerAutomationCheckbox_container__13BbX"};